import { useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { BACKEND_APIS, GROUPED_BY } from "@constants"
import { commonFiltersValue, isLoadingCommonFilters } from "@signals"
import { skuDetailsScores, skuDetailsScoresInLoading } from "../../@signals"


export default function useSkuDetailsReviewsData() {

	const isLoadingReviews = useSignal(false)
	const data = useSignal([])
	const reviewsGroupBy = useSignal([GROUPED_BY.RETAILER])

	const optionSelected = useSignal(GROUPED_BY.RETAILER)

	useEffect(() => {
		if (isLoadingCommonFilters.value) {
			isLoadingReviews.value = true
			data.value = []
			postSubmit(`${BACKEND_APIS.SKU_DETAILS}/reviews`, { ...commonFiltersValue.value, groupedBy: reviewsGroupBy.value }).then(res => batch(() => {
				data.value = res.data
                skuDetailsScores.value["Sentiment"] = res.sentimentScore
			})).finally(() => batch(() => {
				isLoadingReviews.value = false
			}))
		}
	}, [isLoadingCommonFilters.value])

	const handleChangeGroupBy = (e) => {
		optionSelected.value = e.target.value

		if (optionSelected.value === GROUPED_BY.COUNTRY)
			reviewsGroupBy.value = [GROUPED_BY.COUNTRY]

		if (optionSelected.value === GROUPED_BY.RETAILER)
			reviewsGroupBy.value = [GROUPED_BY.COUNTRY, GROUPED_BY.RETAILER]

		isLoadingReviews.value = true
		data.value = []
		postSubmit(`${BACKEND_APIS.SKU_DETAILS}/reviews`, { ...commonFiltersValue.value, groupedBy: reviewsGroupBy.value }).then(res => batch(() => {
			data.value = res.data
		})).finally(() => batch(() => {
			isLoadingReviews.value = false
		}))
	}

	useEffect(() => {
		if (isLoadingReviews.value) {
			skuDetailsScoresInLoading.value = [...skuDetailsScoresInLoading.value, "Reviews"]
		} else {
			skuDetailsScoresInLoading.value = skuDetailsScoresInLoading.value.filter(item => item !== "Reviews")
		}
	}, [isLoadingReviews.value])

	return {
		isLoadingReviews: isLoadingReviews.value,
		data: data.value,
		reviewsGroupBy: reviewsGroupBy.value,
		optionSelected: optionSelected.value,
		
		handleChangeGroupBy
	}
}